var _defs, _tspan;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTsCommon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "110.79427mm",
    height: "132.29166mm",
    viewBox: "0 0 110.79427 132.29166",
    id: "svg94",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs88"
  })), /*#__PURE__*/React.createElement("g", {
    id: "layer1",
    transform: "translate(0,-164.70835)"
  }, /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: "normal",
      fontStretch: "normal",
      fontSize: "10.58333302px",
      lineHeight: 1.25,
      fontFamily: "'Bravura Text'",
      InkscapeFontSpecification: "'Bravura Text, Normal'",
      fontVariantLigatures: "normal",
      fontVariantCaps: "normal",
      fontVariantNumeric: "normal",
      fontFeatureSettings: "normal",
      textAlign: "start",
      letterSpacing: 0,
      wordSpacing: 0,
      writingMode: "lr-tb",
      textAnchor: "start",
      fill: "#000000",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.26458332
    },
    x: 16.630953,
    y: 117.83928,
    id: "text98"
  }, _tspan || (_tspan = /*#__PURE__*/React.createElement("tspan", {
    id: "tspan100",
    x: 16.630953,
    y: 127.62886
  }))), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: "normal",
      fontStretch: "normal",
      fontSize: "50.79999924px",
      lineHeight: 1.25,
      fontFamily: "'Bravura Text'",
      InkscapeFontSpecification: "'Bravura Text'",
      letterSpacing: 0,
      wordSpacing: 0,
      fill: "#000000",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.26458332
    },
    x: 16.630953,
    y: 111.03571,
    id: "text104"
  }, /*#__PURE__*/React.createElement("tspan", {
    id: "tspan102",
    x: 16.630953,
    y: 158.02571,
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: "normal",
      fontStretch: "normal",
      fontSize: "50.79999924px",
      fontFamily: "'Bravura Text'",
      InkscapeFontSpecification: "'Bravura Text'",
      strokeWidth: 0.26458332
    }
  })), /*#__PURE__*/React.createElement("g", {
    "aria-label": "\\uE08A",
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: "normal",
      fontStretch: "normal",
      fontSize: "330.72915649px",
      lineHeight: 1.25,
      fontFamily: "'Bravura Text'",
      InkscapeFontSpecification: "'Bravura Text, Normal'",
      fontVariantLigatures: "normal",
      fontVariantCaps: "normal",
      fontVariantNumeric: "normal",
      fontFeatureSettings: "normal",
      textAlign: "start",
      letterSpacing: 0,
      wordSpacing: 0,
      writingMode: "lr-tb",
      textAnchor: "start",
      fill: "#000000",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 1.72254312
    },
    id: "text108"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 60.192706,164.70835 c -7.937499,0 -17.197916,2.3151 -24.143228,5.29166 C 12.567708,180.25262 0,208.69532 0,233.83074 c 0,2.3151 0,4.63021 0.33072916,7.27604 1.32291664,14.22135 8.26822894,27.78125 16.86718684,38.36458 9.921875,11.90625 24.473958,17.52865 40.348957,17.52865 46.302087,0 53.247397,-42.0026 53.247397,-49.60938 0,-5.95312 -2.97656,-5.95312 -3.96875,-5.95312 -1.98438,0 -3.96875,0.33073 -3.96875,4.96094 0,34.0651 -29.104168,42.0026 -37.372397,42.0026 -21.497395,0 -33.072916,-20.83594 -33.072916,-64.49219 0,-43.65624 20.174479,-52.91666 34.395833,-52.91666 13.890624,0 19.51302,6.61458 19.51302,9.26042 0,2.3151 -0.992188,5.62239 -4.960938,5.62239 -10.583333,0 -16.536457,11.57552 -16.536457,19.51302 0,15.21354 12.898437,19.84375 20.505207,19.84375 0,0 19.843748,-0.66146 19.843748,-22.48958 0,-34.72656 -39.687497,-38.03385 -44.979164,-38.03385 z",
    style: {
      strokeWidth: 1.72254312
    },
    id: "path301"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTsCommon);
export default __webpack_public_path__ + "static/media/ts-common.48dc9a440947f1af4fd7e06c20838299.svg";
export { ForwardRef as ReactComponent };